import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { VisitorModel } from 'client/data/models/visitor';
import { ZipInput } from 'site-modules/shared/components/zip-input/zip-input';
import { validation } from 'site-modules/shared/components/form-validation/validation';
import { CalculatorRowItem } from 'site-modules/calculators/components/calculator-row-item/calculator-row-item';

/**
 * Renders zip code styled for any calculator page.
 * @param {string} city
 * @param {string} stateCode
 * @param {string} zipCode
 * @returns {ReactElement}
 */
export function CalculatorZipCodeUI({
  city = '',
  stateCode = '',
  zipCode = '',
  TitleWrapper = Fragment,
  overrideWrapperClass = false,
}) {
  return (
    <CalculatorRowItem
      title="Zip Code"
      subtitle={`(for rates and pricing in ${city}, ${stateCode})`}
      TitleWrapper={TitleWrapper}
      overrideWrapperClass={overrideWrapperClass}
    >
      <ZipInput onValidate={validation.validateZip} inputClasses="ps-0_25" zipCode={zipCode} />
    </CalculatorRowItem>
  );
}

CalculatorZipCodeUI.propTypes = {
  city: PropTypes.string,
  stateCode: PropTypes.string,
  zipCode: PropTypes.string,
  TitleWrapper: PropTypes.node,
  overrideWrapperClass: PropTypes.bool,
};

export const stateToPropsConfig = {
  city: bindToPath('location.city', VisitorModel),
  stateCode: bindToPath('location.stateCode', VisitorModel),
};

export const CalculatorZipCode = connectToModel(CalculatorZipCodeUI, stateToPropsConfig);
